module.exports = __webpack_public_path__ + "img/fm-logo.35cc35d1.webp";